import axios from 'axios';

const apiClient = axios.create({
  timeout: 3000
});

export default apiClient;
export * from 'axios';
